// IndexDB 是一个运行在浏览器上的非关系型数据库

// 使用索引实现对数据的高性能搜索，使用上接近于数据库
// 能够解决 Web Storage 在存储 大量的结构化数据时存储容量小，搜索速度慢等问题

// 理论上来说，IndexDB 是没有存储上限的（一般来说不会小于 250M）

// 遵守同源策略

// 支持二进制存储：不仅可以存储字符串，也可以存储 File 或 Blob 对象

// IndexedDB 操作默认为异步操作

// 创建表
function ensureTable(db: IDBDatabase, tableName: string) {
  let objectStore;
  if (!db.objectStoreNames.contains(tableName)) {
    objectStore = db.createObjectStore(tableName, { keyPath: "id" });
  }
  return objectStore;
}

export function createIndexDB(
  dbName: string,
  dbVersion = 1,
  tableName: string
) {
  return new Promise((resolve, reject) => {
    let db: IDBDatabase;
    const request: IDBOpenDBRequest = window.indexedDB.open(dbName, dbVersion);
    request.onerror = () => {
      reject("无法使用IndexDB!");
    };
    request.onsuccess = (e) => {
      db = (e.target as IDBRequest).result;
      ensureTable(db, tableName);
      resolve(db);
    };
    // 在 初始化数据库 / 版本发生更新时被调用
    // request.onupgradeneeded = request.onsuccess;
  });
}

export function writeToIndexDB(
  db: IDBDatabase,
  tableName: string,
  json: Record<string, string | number> = { id: 1, name: "xxx" }
) {
  return new Promise((resolve, reject) => {
    const transaction: IDBTransaction = db.transaction(
      [tableName],
      "readwrite"
    );
    const objectStore: IDBObjectStore = transaction.objectStore(tableName);
    objectStore.add(json);
    transaction.oncomplete = (e) => {
      resolve(e);
    };
    transaction.onerror = (e) => {
      reject(e);
    };
  });
}
